import { HERO_IMAGE_SIZES, IMAGE_WIDTHS } from '../../../core/constants/images';
import { ROUTES, SECTION_IDS } from '../../../core/constants/navigation';
import Button from '../../../common/components/Button/Button';
import ResponsiveImage from '../../../common/components/ResponsiveImage/ResponsiveImage';
import { IconArrowRight, IconCheck, IconCode, IconVideo } from '../../../common/icons';

import '../styles/hero.css';

const PILLARS = ['Asesoría estratégica', 'Marketing digital', 'Producción audiovisual', 'Desarrollo web'];

export default function Hero() {
    return (
        <section className="hero" aria-labelledby="hero-title">
            <div className="hero__backdrop" aria-hidden="true" />

            <div className="hero__inner layout-container">
                <div className="hero__content">
                    <p className="hero__badge">
                        <span className="hero__badge-dot" aria-hidden="true" />
                        Agencia integral para medios y marcas
                    </p>
                    <h1 id="hero-title" className="hero__title">
                        Todo lo que necesitas para tu <span className="hero__highlight">medio</span>.
                    </h1>
                    <p className="hero__lead">
                        Te acompañamos con asesoría estratégica, marketing digital, producción audiovisual y
                        desarrollo web para que tu medio crezca, conecte con su audiencia y sea sostenible.
                    </p>
                    <div className="hero__actions">
                        <Button to={{ pathname: ROUTES.HOME, hash: `#${SECTION_IDS.CONTACT}` }} icon={<IconArrowRight />}>
                            Solicita tu asesoría
                        </Button>
                        <Button to={{ pathname: ROUTES.HOME, hash: `#${SECTION_IDS.SERVICES}` }} variant="outline">
                            Conoce los servicios
                        </Button>
                    </div>
                    <ul className="hero__pillars" aria-label="Líneas de servicio">
                        {PILLARS.map(pillar => (
                            <li key={pillar} className="hero__pillar">
                                <IconCheck />
                                {pillar}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="hero__visual">
                    <div className="hero__shape hero__shape--primary" aria-hidden="true" />
                    <div className="hero__shape hero__shape--accent" aria-hidden="true" />
                    <div className="hero__frame">
                        <ResponsiveImage
                            name="hero"
                            widths={IMAGE_WIDTHS.HERO}
                            sizes={HERO_IMAGE_SIZES}
                            width={1280}
                            height={1600}
                            isPriority
                            className="hero__image"
                            alt="Camarógrafo grabando una producción audiovisual en un estudio iluminado"
                        />
                    </div>
                    <div className="hero__card hero__card--top">
                        <span className="hero__card-icon hero__card-icon--accent"><IconVideo /></span>
                        <span className="hero__card-text">
                            <strong>Producción audiovisual</strong>
                            <span>Coberturas, spots y podcast</span>
                        </span>
                    </div>
                    <div className="hero__card hero__card--bottom">
                        <span className="hero__card-icon"><IconCode /></span>
                        <span className="hero__card-text">
                            <strong>Plataformas web</strong>
                            <span>Portales rápidos y seguros</span>
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}
